import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ROUTES } from '../../../routes/urls';
import { BackButtonMainDiv, Content, MainDiv } from './styles';
import LayoutWithoutNavbar from '../../layoutWithoutNavbar';
import { useMobileDevice } from '../../../global/useMobile';
import ResponsiveHeader from '../../responsiveHeader';
import BottomSubNavigation from '../../bottomNavigation/subNavigation';
import { NavbarMain } from '../settingNavbar/styles';
import MenuSection from '../menuSection';
import { reportMenuData } from '../../../global/row';
import NavbarActionButton from '../../navbarActionButton';
import { ICON_SIZE } from '../../../global/constants';

const ReportNavbar: React.FC = () => {
  //Other variable
  const history = useHistory();
  const mobile = useMobileDevice();

  const onClickReports = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history]
  );

  const renderReportMenu = useCallback(() => {
    return reportMenuData.map((item) => <MenuSection key={item.title} title={item.title} items={item.items} />);
  }, []);
  return (
    <>
      <LayoutWithoutNavbar>
        <NavbarMain className='report-navbar'>
          {mobile && <ResponsiveHeader title='Reports' noMargin={true} />}
          <Content>
            {!mobile && (
              <BackButtonMainDiv>
                <NavbarActionButton
                  className='desktop-profile'
                  text={'Reports'}
                  isPadding={true}
                  icon={
                    <SVGIcon
                      name='new-back-arrow-icon'
                      width={ICON_SIZE.MD}
                      height={ICON_SIZE.MD}
                      viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                    />
                  }
                  onClick={() => onClickReports(ROUTES.INBOX)}
                />
              </BackButtonMainDiv>
            )}

            <MainDiv>{renderReportMenu()}</MainDiv>
          </Content>
        </NavbarMain>
      </LayoutWithoutNavbar>
      <BottomSubNavigation />
    </>
  );
};

export default ReportNavbar;
